import { createSelector } from '@ngrx/store';

export const selectTagsState = state => state.tags;

export const tagsList = createSelector(
  selectTagsState,
  state => state.tags
);